module.exports = __webpack_public_path__ + "img/cover-redeem-bg.237eb9d3.jpg";